import React, { useState } from "react";
import ReactStars from "react-rating-stars-component"; // For star rating

const FormPreview = ({ fields }) => {

    // const [formData, setFormData] = useState(
    //     fields.reduce((acc, field) => {
    //         acc[field.id] =
    //             field.type === "checkboxes" || field.type === "radio"
    //                 ? []
    //                 : "";
    //         return acc;
    //     }, {})
    // );

    // new addition
    const [formData, setFormData] = useState(() => {
        const initialData = {};
        fields.forEach(field => {
            // Initialize main field
            initialData[field.id] = field.type === "checkboxes" ? [] : "";
            
            // Initialize conditional fields if they exist
            if (field.type === "dropdown" && field.conditions) {
                Object.keys(field.conditions).forEach(option => {
                    if (field.conditions[option].enabled) {
                        field.conditions[option].fields.forEach(conditionalField => {
                            initialData[conditionalField.id] = 
                                conditionalField.type === "checkboxes" ? [] : "";
                        });
                    }
                });
            }
        });
        return initialData;
    });
    const [visibleConditionalFields, setVisibleConditionalFields] = useState({});


    // const handleInputChange = (id, value) => {
    //     setFormData((prevData) => ({
    //         ...prevData,
    //         [id]: value,
    //     }));
    // };

    // new addition
    // Modify handleInputChange to handle conditional fields
    const handleInputChange = (id, value, parentFieldId = null) => {
        setFormData(prevData => {
            const newData = { ...prevData, [id]: value };

            // If this is a dropdown field that might have conditional fields
            const field = fields.find(f => f.id === id);
            if (field?.type === "dropdown" && field.conditions) {
                // Clear previous conditional field values
                Object.keys(field.conditions).forEach(option => {
                    if (field.conditions[option].enabled) {
                        field.conditions[option].fields.forEach(conditionalField => {
                            newData[conditionalField.id] = "";
                        });
                    }
                });
            }
            

            return newData;
        });
    };

    // Add this function to get the complete form data including conditional fields
    const getFormDataWithConditionals = () => {
        const completeData = { ...formData };
        
        fields.forEach(field => {
            if (field.type === "dropdown" && field.conditions && field.conditions[formData[field.id]]?.enabled) {
                completeData[`${field.id}_conditional`] = {
                    selectedOption: formData[field.id],
                    conditionalFields: field.conditions[formData[field.id]].fields.reduce((acc, conditionalField) => {
                        acc[conditionalField.id] = formData[conditionalField.id];
                        return acc;
                    }, {})
                };
            }
        });

        return completeData;
    };

    const handleCheckboxChange = (id, option) => {
        setFormData((prevData) => {
            const currentValues = prevData[id] || [];
            const updatedValues = currentValues.includes(option)
                ? currentValues.filter((val) => val !== option)
                : [...currentValues, option];
            return { ...prevData, [id]: updatedValues };
        });
    };

    // new addition
    const handleDropdownChange = (id, value) => {
        setFormData({
        ...formData,
        [id]: value
        });

        // Check for conditional fields
        const field = fields.find(f => f.id === id);
        if (field?.conditions?.[value]?.enabled) {
        setVisibleConditionalFields({
            ...visibleConditionalFields,
            [id]: value
        });
        } else {
        const newVisibleFields = { ...visibleConditionalFields };
        delete newVisibleFields[id];
        setVisibleConditionalFields(newVisibleFields);
        }
    };
    
    const renderField = (field) => {
        // Add conditional field rendering logic here
        if (field.type === 'dropdown') {
        return (
            <div key={field.id}>
            <select
                value={formData[field.id] || ''}
                onChange={(e) => handleDropdownChange(field.id, e.target.value)}
                className="w-full border px-2 py-1 rounded"
            >
                <option value="">Select an option</option>
                {field.options.map((option, index) => (
                <option key={index} value={option}>
                    {option}
                </option>
                ))}
            </select>

            {/* Render conditional fields if they exist and should be shown */}
            {field.conditions?.[formData[field.id]]?.enabled && (
                <div className="ml-4 mt-2 border-l-2 pl-4">
                {field.conditions[formData[field.id]].fields.map(conditionalField => 
                    renderField(conditionalField)
                )}
                </div>
            )}
            </div>
        );
        }
    }

    const handleMatrixGridChange = (fieldId, rowIndex, value) => {
        setFormData((prev) => {
            const updated = { ...(prev[fieldId] || []) };
            updated[rowIndex] = value;
            return { ...prev, [fieldId]: updated };
        });
    };

    const handleRepeatGroupChange = (fieldId, index, key, value) => {
        setFormData((prev) => {
            const entries = [...(prev[fieldId] || [{}])];
            entries[index] = { ...entries[index], [key]: value };
            return { ...prev, [fieldId]: entries };
        });
    };

    const addRepeatGroup = (fieldId) => {
        setFormData((prev) => {
            const entries = [...(prev[fieldId] || [])];
            entries.push({ name: "", email: "" });
            return { ...prev, [fieldId]: entries };
        });
    };

    const removeRepeatGroup = (fieldId, index) => {
        setFormData((prev) => {
            const entries = [...(prev[fieldId] || [])];
            entries.splice(index, 1);
            return { ...prev, [fieldId]: entries };
        });
    };

    return (

        <div className="flex-1 p-8 bg-gradient-to-br from-white/90 via-blue-50/80 to-indigo-100/70 dark:from-gray-900/90 dark:via-slate-900/80 dark:to-indigo-950/70 shadow-2xl shadow-black/10 overflow-y-auto rounded-3xl backdrop-blur-xl border border-white/20 dark:border-gray-700/30 relative">
            {/* Decorative Background Elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-10 right-10 w-32 h-32 bg-gradient-to-br from-blue-400/10 to-purple-600/10 rounded-full blur-2xl animate-pulse"></div>
                <div className="absolute bottom-10 left-10 w-40 h-40 bg-gradient-to-tr from-indigo-400/10 to-cyan-600/10 rounded-full blur-2xl animate-pulse" style={{animationDelay: '1.5s'}}></div>
            </div>

            <div className="relative z-10">
                <div className="flex items-center gap-4 mb-8">
                    <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-full animate-pulse"></div>
                    <h3 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-gray-900 via-blue-900 to-indigo-900 dark:from-white dark:via-blue-100 dark:to-indigo-100">
                        Form Preview
                    </h3>
                </div>

                {fields.length === 0 ? (
                    <div className="text-center py-16">
                        <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-600 rounded-3xl flex items-center justify-center">
                            <div className="w-12 h-12 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-2xl opacity-50"></div>
                        </div>
                        <p className="text-xl font-semibold text-gray-500 dark:text-gray-400">
                            No fields to preview yet
                        </p>
                        <p className="text-gray-400 dark:text-gray-500 mt-2">
                            Add some fields to see them come to life here!
                        </p>
                    </div>
                ) : (
                    <form className="space-y-8">
                        {fields.map((field) => (

                            <div key={field.id} className="transform hover:scale-[1.02] transition-all duration-300">
                                {/* Section Field */}
                                {/* {field.description} */}
                                {field.type === "form-header" ? (
                                    <div key={field.id} className="mb-8">
                                        <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                                            {field.label}
                                        </h2>
                                        {field.showDivider && (
                                            <hr className="my-4 border-t-2 border-gray-300 dark:border-gray-600 mx-auto " />
                                        )}
                                        <p className="text-lg text-gray-600 dark:text-gray-300">
                                            {field.description}
                                        </p>
                                    </div>
                                ) : field.type === "section" ? (
                                    <div
                                        key={field.id}
                                        className="bg-gradient-to-r from-blue-100/80 via-indigo-100/60 to-purple-100/80 dark:from-gray-800/80 dark:via-slate-800/60 dark:to-indigo-900/80 p-8 rounded-3xl shadow-lg border border-blue-200/50 dark:border-gray-700/50 backdrop-blur-sm"
                                    >
                                        <h4 className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-700 dark:from-blue-300 dark:to-indigo-400 mb-3">
                                            {field.sectionTitle || "Section Title"}
                                        </h4>
                                        <p className="text-lg text-gray-600 dark:text-gray-300 font-medium">
                                            {field.sectionDescription || "Section Description"}
                                        </p>
                                    </div>
                                ) : (
                                    <div className="bg-white/60 dark:bg-gray-800/60 p-6 rounded-2xl shadow-lg border border-white/30 dark:border-gray-700/30 backdrop-blur-sm hover:shadow-xl transition-all duration-300">
                                        {/* Field Label */}
                                        <label
                                            className="block mb-4 text-lg font-bold text-gray-800 dark:text-white"
                                            htmlFor={field.id}
                                        >
                                            {field.label}
                                            {field.required && (
                                                <span className="text-red-500 ml-2 text-xl">*</span>
                                            )}
                                        </label>

                                        {field.type === "image" && field.image_url && (
                                            <div className="flex flex-col items-center mb-8">
                                                <img
                                                    src={field.image_url}
                                                    alt={field.alt_text || "Form image"}
                                                    className="w-full object-cover max-h-48 rounded shadow border"
                                                />
                                                {field.alt_text && (
                                                    <p className="text-gray-500 text-sm mt-2">{field.alt_text}</p>
                                                )}
                                            </div>
                                        )}

                                        {/* Field Types */}
                                        {field.type === "short-answer" && (
                                            <input
                                                id={field.id}
                                                type="text"
                                                className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner text-lg font-medium placeholder-gray-400 dark:placeholder-gray-500"
                                                placeholder={field.placeholder || "Enter your answer"}
                                                value={formData[field.id] || ""}
                                                onChange={(e) =>
                                                    handleInputChange(field.id, e.target.value)
                                                }
                                                required={field.required}
                                            />
                                        )}

                                        {field.type === "number" && (
                                            <input
                                                id={field.id}
                                                type="number"
                                                className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner text-lg font-medium placeholder-gray-400 dark:placeholder-gray-500"
                                                placeholder={field.placeholder || "Enter your answer"}
                                                value={formData[field.id] || ""}
                                                onChange={(e) =>
                                                    handleInputChange(field.id, e.target.value)
                                                }
                                                min={0}
                                                required={field.required}
                                            />
                                        )}

                                        {field.type === "mobile" && (
                                            <input
                                                id={field.id}
                                                type="tel"
                                                pattern="[0-9]{10}"
                                                className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner text-lg font-medium placeholder-gray-400 dark:placeholder-gray-500"
                                                placeholder={field.placeholder || "Enter mobile number"}
                                                value={formData[field.id] || ""}
                                                onChange={(e) => handleInputChange(field.id, e.target.value)}
                                                required={field.required}
                                            />
                                        )}

                                        {field.type === "phone" && (
                                            <input
                                                id={field.id}
                                                type="tel"
                                                className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner text-lg font-medium placeholder-gray-400 dark:placeholder-gray-500"
                                                placeholder={field.placeholder || "Enter phone number"}
                                                value={formData[field.id] || ""}
                                                onChange={(e) => handleInputChange(field.id, e.target.value)}
                                                required={field.required}
                                            />
                                        )}

                                        {field.type === "email" && (
                                            <input
                                                id={field.id}
                                                type="email"
                                                className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner text-lg font-medium placeholder-gray-400 dark:placeholder-gray-500"
                                                placeholder={field.placeholder || "Enter email address"}
                                                value={formData[field.id] || ""}
                                                onChange={(e) => handleInputChange(field.id, e.target.value)}
                                                required={field.required}
                                            />
                                        )}

                                        {field.type === "long-answer" && (
                                            <textarea
                                                id={field.id}
                                                rows="4"
                                                className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner text-lg font-medium placeholder-gray-400 dark:placeholder-gray-500 resize-none"
                                                placeholder={field.placeholder || "Enter detailed answer"}
                                                value={formData[field.id] || ""}
                                                onChange={(e) =>
                                                    handleInputChange(field.id, e.target.value)
                                                }
                                                required={field.required}
                                            />
                                        )}

                                        {field.type === "radio" && (
                                            <div className="flex flex-col space-y-4">
                                                {field.options?.map((option, index) => (
                                                    <label
                                                        key={index}
                                                        className="flex items-center gap-4 p-3 rounded-xl hover:bg-blue-50/50 dark:hover:bg-gray-700/50 transition-all duration-200 cursor-pointer group"
                                                    >
                                                        <div className="relative">
                                                            <input
                                                                type="radio"
                                                                name={field.id}
                                                                value={option}
                                                                checked={formData[field.id] === option}
                                                                onChange={() => handleInputChange(field.id, option)}
                                                                required={field.required}
                                                                className="w-5 h-5 text-blue-600 border-2 border-gray-300 focus:ring-blue-500 focus:ring-2"
                                                            />
                                                        </div>
                                                        <span className="text-lg font-medium text-gray-700 dark:text-gray-200 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-200">
                                                            {option}
                                                        </span>
                                                    </label>
                                                ))}
                                            </div>
                                        )}

                                        {field.type === "checkboxes" && (
                                            <div className="flex flex-col space-y-4">
                                                {field.options?.map((option, index) => (
                                                    <label
                                                        key={index}
                                                        className="flex items-center gap-4 p-3 rounded-xl hover:bg-blue-50/50 dark:hover:bg-gray-700/50 transition-all duration-200 cursor-pointer group"
                                                    >
                                                        <div className="relative">
                                                            <input
                                                                type="checkbox"
                                                                checked={(formData[field.id] || []).includes(
                                                                    option
                                                                )}
                                                                onChange={() =>
                                                                    handleCheckboxChange(field.id, option)
                                                                }
                                                                className="w-5 h-5 text-blue-600 border-2 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                                                            />
                                                        </div>
                                                        <span className="text-lg font-medium text-gray-700 dark:text-gray-200 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors duration-200">
                                                            {option}
                                                        </span>
                                                    </label>
                                                ))}
                                            </div>
                                        )}

                                        {field.type === "dropdown" && (
                                            <div>
                                                <select
                                                    id={field.id}
                                                    className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner text-lg font-medium appearance-none cursor-pointer"
                                                    value={formData[field.id] || ""}
                                                    onChange={(e) =>
                                                        handleDropdownChange(field.id, e.target.value)
                                                    }
                                                    required={field.required}
                                                >
                                                    <option value="" disabled className="text-gray-500">
                                                        Select an option
                                                    </option>
                                                    {field.options?.map((option, index) => (
                                                        <option key={index} value={option} className="text-gray-900 dark:text-white">
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Render conditional fields if they exist and should be shown */}
                                                {field.conditions?.[formData[field.id]]?.enabled && (
                                                <div className="ml-6 mt-6 border-l-4 border-gradient-to-b from-blue-400 to-indigo-500 pl-6 bg-gradient-to-r from-blue-50/30 to-indigo-50/30 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-r-2xl py-4">
                                                    {field.conditions[formData[field.id]].fields.map(conditionalField => (
                                                    <div key={conditionalField.id} className="mb-6 last:mb-0">
                                                        <label className="block mb-3 text-lg font-bold text-gray-800 dark:text-white">
                                                        {conditionalField.label}
                                                        {conditionalField.required && <span className="text-red-500 ml-2 text-xl">*</span>}
                                                        </label>
                                                        {/* Render the conditional field based on its type */}
                                                        {/* You can reuse your existing field rendering logic here */}
                                                        {/* This is just a basic example for text input */}
                                                        <input
                                                        type="text"
                                                        className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-3 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner font-medium placeholder-gray-400 dark:placeholder-gray-500"
                                                        value={formData[conditionalField.id] || ""}
                                                        onChange={(e) => handleInputChange(conditionalField.id, e.target.value)}
                                                        required={conditionalField.required}
                                                        />
                                                    </div>
                                                    ))}
                                                </div>
                                                )}
                                            </div>
                                        )}

                                        {field.type === "date" && (
                                            <input
                                                id={field.id}
                                                type="date"
                                                className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner text-lg font-medium"
                                                value={formData[field.id] || ""}
                                                onChange={(e) =>
                                                    handleInputChange(field.id, e.target.value)
                                                }
                                                required={field.required}
                                            />
                                        )}

                                        {field.type === "date-time" && (
                                            <input
                                                id={field.id}
                                                type="datetime-local"
                                                className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm shadow-inner text-lg font-medium"
                                                value={formData[field.id] || ""}
                                                onChange={(e) =>
                                                    handleInputChange(field.id, e.target.value)
                                                }
                                                required={field.required}
                                            />
                                        )}

                                        {field.type === "file-upload" && (
                                            <div className="relative">
                                                <input
                                                    id={field.id}
                                                    type="file"
                                                    className="w-full border-2 border-dashed border-gray-300/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-8 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 transition-all duration-300 backdrop-blur-sm text-lg font-medium file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:bg-blue-500 file:text-white file:font-semibold hover:file:bg-blue-600"
                                                    onChange={(e) =>
                                                        handleInputChange(
                                                            field.id,
                                                            e.target.files[0]?.name || ""
                                                        )
                                                    }
                                                    required={field.required}
                                                />
                                                <div className="absolute inset-0 pointer-events-none flex items-center justify-center text-gray-400 dark:text-gray-500">
                                                    <div className="text-center">
                                                        <div className="w-12 h-12 mx-auto mb-2 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-xl opacity-20"></div>
                                                        <p className="font-medium">Click to upload or drag and drop</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )}

                                        {field.type === "star-rating" && (
                                            <div className="flex items-center justify-center py-4">
                                                <ReactStars
                                                    count={field.maxRating || 5}
                                                    size={40}
                                                    activeColor="#3b82f6"
                                                    inactiveColor="#e5e7eb"
                                                    value={formData[field.id] || 0}
                                                    onChange={(value) => handleInputChange(field.id, value)}
                                                />
                                            </div>
                                        )}

                                        {field.type === "linear-scale" && (
                                            <div className="py-4">
                                                <div className="flex items-center gap-6 mb-4">
                                                    <span className="text-lg font-bold text-gray-600 dark:text-gray-300 min-w-[2rem] text-center">
                                                        {field.min || 1}
                                                    </span>
                                                    <div className="flex-1 relative">
                                                        <input
                                                            id={field.id}
                                                            type="range"
                                                            min={field.min || 1}
                                                            max={field.max || 10}
                                                            value={formData[field.id] || field.min || 1}
                                                            onChange={(e) =>
                                                                handleInputChange(field.id, e.target.value)
                                                            }
                                                            className="w-full h-3 bg-gray-200 dark:bg-gray-700 rounded-full appearance-none cursor-pointer slider"
                                                        />
                                                        <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-blue-500 text-white px-3 py-1 rounded-lg text-sm font-bold">
                                                            {formData[field.id] || field.min || 1}
                                                        </div>
                                                    </div>
                                                    <span className="text-lg font-bold text-gray-600 dark:text-gray-300 min-w-[2rem] text-center">
                                                        {field.max || 10}
                                                    </span>
                                                </div>
                                            </div>
                                        )}

                                        {field.type === "secret_token" && (
                                            <input
                                                id={field.id}
                                                type="hidden"
                                                value={formData[field.id] || field.default_value || ""}
                                                readOnly
                                            />
                                        )}

                                        {field.type === "user_password" && (
                                            <input
                                                id={field.id}
                                                type="password"
                                                className="w-full border-2 border-gray-200/50 dark:border-gray-600/50 dark:bg-gray-900/50 dark:text-white px-5 py-4 rounded-xl focus:border-blue-500 focus:ring-4 focus:ring-blue-200/50 dark:focus:ring-blue-800/50 shadow-inner placeholder-gray-400 dark:placeholder-gray-500"
                                                placeholder={field.placeholder || "Enter password"}
                                                value={formData[field.id] || ""}
                                                onChange={(e) => handleInputChange(field.id, e.target.value)}
                                                required={field.required}
                                            />
                                        )}

                                        {field.type === "enable_notification" && (
                                            <label className="flex items-center gap-3">
                                                <input
                                                    type="checkbox"
                                                    checked={formData[field.id] || false}
                                                    onChange={(e) => handleInputChange(field.id, e.target.checked)}
                                                    className="w-6 h-6 text-blue-600 rounded border-gray-300 dark:bg-gray-900 dark:border-gray-600"
                                                />
                                                <span className="text-gray-700 dark:text-white text-lg font-medium">
                                                    {field.placeholder || "Enable Notifications"}
                                                </span>
                                            </label>
                                        )}

                                        {field.type === "e_signature" && (
                                            <div className="w-full h-40 border-2 border-dashed rounded-xl flex items-center justify-center text-gray-400 dark:text-gray-600 bg-white/30 dark:bg-gray-900/30">
                                                Signature Pad (Preview Only)
                                            </div>
                                        )}

                                        {field.type === "grid" && (
                                            <div className="overflow-x-auto">
                                                <table className="w-full border border-gray-300 dark:border-gray-600 text-sm text-left text-gray-700 dark:text-gray-300">
                                                    <thead className="bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-gray-200">
                                                        <tr>
                                                            <th className="border px-4 py-2">Question</th>
                                                            {(field.columns || []).map((col, idx) => (
                                                                <th key={idx} className="border px-4 py-2 text-center">{col}</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {(field.questions || ["Q1", "Q2"]).map((question, rowIdx) => (
                                                            <tr key={rowIdx}>
                                                                <td className="border px-4 py-2">{question}</td>
                                                                {(field.columns || []).map((col, colIdx) => (
                                                                    <td key={colIdx} className="border px-4 py-2 text-center">
                                                                        <input
                                                                            type="radio"
                                                                            name={`${field.id}_${rowIdx}`}
                                                                            value={col}
                                                                            checked={(formData[field.id]?.[rowIdx] || "") === col}
                                                                            onChange={() =>
                                                                                handleMatrixGridChange(field.id, rowIdx, col)
                                                                            }
                                                                            className="w-4 h-4"
                                                                        />
                                                                    </td>
                                                                ))}
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        {field.type === "repeat_group" && (
                                            <div className="space-y-4">
                                                {(formData[field.id] || [{}]).map((entry, idx) => (
                                                    <div
                                                        key={idx}
                                                        className="flex flex-col md:flex-row gap-4 items-center border border-gray-300 dark:border-gray-600 p-4 rounded-xl bg-white/20 dark:bg-gray-900/30"
                                                    >
                                                        <input
                                                            type="text"
                                                            placeholder="Name"
                                                            value={entry.name || ""}
                                                            onChange={(e) => handleRepeatGroupChange(field.id, idx, 'name', e.target.value)}
                                                            className="flex-1 border px-4 py-2 rounded dark:bg-black dark:text-white"
                                                        />
                                                        <input
                                                            type="email"
                                                            placeholder="Email"
                                                            value={entry.email || ""}
                                                            onChange={(e) => handleRepeatGroupChange(field.id, idx, 'email', e.target.value)}
                                                            className="flex-1 border px-4 py-2 rounded dark:bg-black dark:text-white"
                                                        />
                                                        <button
                                                            type="button"
                                                            onClick={() => removeRepeatGroup(field.id, idx)}
                                                            className="text-red-500 hover:underline text-sm"
                                                        >
                                                            Remove
                                                        </button>
                                                    </div>
                                                ))}
                                                <button
                                                    type="button"
                                                    onClick={() => addRepeatGroup(field.id)}
                                                    className="px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded text-sm"
                                                >
                                                    Add Entry
                                                </button>
                                            </div>
                                        )}

                                    </div>
                                )}
                            </div>
                        ))}
                    </form>
                )}
            </div>
        </div>
    );
};

export default FormPreview;
